
export type ApplicationSettings = {
    employeePortalSettings: EmployeePortalSettings
};

export function getDefaultApplicationSettings (): ApplicationSettings
{
    return {
        employeePortalSettings: getDefaultEmployeePortalSettings()
    };
}

export function getDefaultEmployeePortalSettings (): EmployeePortalSettings
{
    return {
        enabled: false,
        resetTimeStamp: new Date(0), // Default to epoch, meaning no sessions are invalidated
        authentication:{
            magicLink:{
                enabled:false,
                validDomains:[]
            },
            publicKey:{
                enabled:false,
                accessKey:''
            }
        }
    };
}

export type EmployeePortalSettings = {
    enabled: boolean,
    resetTimeStamp: Date, // All session created before this timestamp will be invalidated
    authentication:{
        magicLink:{
            enabled:boolean,
            validDomains:string[]
        },
        publicKey:{
            enabled:boolean,
            accessKey:string // The key that must be provided by the client to authenticate. Should be long and random to prevent guessing
        }
    }
}
